import { render, staticRenderFns } from "./PricingManagement.vue?vue&type=template&id=f59b409a&scoped=true"
import script from "./PricingManagement.vue?vue&type=script&lang=js"
export * from "./PricingManagement.vue?vue&type=script&lang=js"
import style0 from "./PricingManagement.vue?vue&type=style&index=0&id=f59b409a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59b409a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VMenu})
